<template>
  <div class="create-btns-area">
    <template
      v-if="createMode === -1 && (!content || (content && content.ctxId))"
    >
      <v-btn
        :ref="'add-content-btn-' + item.menuId"
        plain
        @click.stop="clickCreateContent('Html')"
        ><v-icon left>mdi-format-text</v-icon>新增一般內文</v-btn
      >

      <v-btn
        :ref="'add-content-btn-' + item.menuId"
        plain
        @click.stop="clickCreateContent('Panel')"
        ><v-icon left>mdi-server</v-icon>新增手風琴內文</v-btn
      >
    </template>
    <div v-else-if="newData.format != '' && createMode == 1">
      <component
        :is="currEditObj.format"
        :data="currEditObj"
        :hoverColor="false"
        :modifyMode="false"
        :beAbleEdit="false"
      ></component>
    </div>
  </div>
</template>

<script>
import Html from '@/components/elements/contentType/Html.vue'
import Panel from '@/components/elements/contentType/Panel.vue'
import Table from '@/components/elements/contentType/Table.vue'

import { mapState, mapActions } from 'vuex'
export default {
  name: 'CreateBtens',

  props: ['item', 'content'],

  components: { Panel, Html, Table },

  data() {
    return {
      newData: {
        format: '',
        content: '',
        followId: 0,
        parentId: 0
      }
    }
  },

  computed: {
    ...mapState('document', ['countentsFromDB', 'currEditObj', 'createMode'])
  },

  methods: {
    ...mapActions('document', ['setCreateMode']),
    clickCreateContent(type) {
      this.newData.format = type
      this.newData.content =
        type === 'Panel'
          ? [{ title: '', text: '' }]
          : ''
      this.newData.followId = this.content ? this.content.ctxId : 0
      this.newData.parentId = this.item.menuId
      this.newData.sn = this.content ? this.content.sn + 1 : 0
      this.setCreateMode({
        obj: JSON.parse(JSON.stringify(this.newData)),
        mode: 1
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.create-btns-area {
  margin: 6px 0;
  .v-btn {
    margin-right: 8px;
  }
}
</style>
